import { useRecordContext } from 'react-admin';
import type { IData } from '../../../../types';

const RemoveActionNames = ['', 'REMOVED', 'UPDATED', 'DELISTED'];
export const ActionFormatter = (props: IData) => {
    const record = useRecordContext(props);
    return RemoveActionNames[record.action];
};

ActionFormatter.defaultProps = { label: 'action' };
